import React from 'react';
import { Alert, FormControlLabel, MenuItem, Radio, RadioGroup, TextField } from '@mui/material';

import { SIGNUP_TARGETS } from '../../../common/signupLinkApi.js';

// Which Welcome Email Template to send, and where its Welcome Link lands the recipient.
const WelcomeEmailChoice = ({ templates, templateId, onTemplateChange, target, onTargetChange, disabled }) => (
    <div className="setup-form-section">
        <div className="setup-form-section-header">
            <h3>Velkomstmail</h3>
        </div>
        {templates.length === 0 ? (
            <Alert severity="info">
                Der er ingen e-mailskabeloner endnu. Opret en under "E-mailskabeloner".
            </Alert>
        ) : (
            <TextField
                select
                label="Skabelon"
                value={templateId}
                onChange={(event) => onTemplateChange(event.target.value)}
                size="small"
                disabled={disabled}
                SelectProps={{ MenuProps: { classes: { paper: 'setup-autocomplete-paper' } } }}
            >
                {templates.map((template) => (
                    <MenuItem key={template.id} value={template.id}>
                        {template.name}
                    </MenuItem>
                ))}
            </TextField>
        )}
        <RadioGroup
            row
            value={target}
            onChange={(event) => onTargetChange(event.target.value)}
            className="welcome-target-group"
        >
            {Object.entries(SIGNUP_TARGETS).map(([value, { label }]) => (
                <FormControlLabel
                    key={value}
                    value={value}
                    control={<Radio />}
                    label={`Videre til ${label}`}
                    disabled={disabled}
                />
            ))}
        </RadioGroup>
    </div>
);

export default WelcomeEmailChoice;
